import React, { useState } from 'react';
import { QUIZ_QUESTIONS } from '../types';
import Button from './ui/Button';
import { tracking } from '../services/tracking';

interface QuizProps {
  onComplete: (answers: number[]) => void;
}

const Quiz: React.FC<QuizProps> = ({ onComplete }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState<number[]>([]);
  const [direction, setDirection] = useState<'next' | 'prev'>('next');

  const currentQuestion = QUIZ_QUESTIONS[currentQuestionIndex];
  const progress = ((currentQuestionIndex + 1) / QUIZ_QUESTIONS.length) * 100;

  const handleOptionSelect = (optionIndex: number) => {
    const newAnswers = [...answers, optionIndex];

    // Track Step
    tracking.trackEvent('quiz_step_complete', {
      step: currentQuestionIndex + 1,
      question_id: currentQuestion.id,
      answer_index: optionIndex
    });

    if (currentQuestionIndex < QUIZ_QUESTIONS.length - 1) {
      setAnswers(newAnswers);
      setDirection('next');
      setTimeout(() => setCurrentQuestionIndex(prev => prev + 1), 250); // Small delay for visual feedback
    } else {
      onComplete(newAnswers);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 max-w-2xl mx-auto">

      {/* Progress Bar */}
      <div className="w-full max-w-md mb-12">
        <div className="flex justify-between text-xs font-semibold text-brand-neon mb-2 uppercase tracking-widest">
          <span>Progresso</span>
          <span>{currentQuestionIndex + 1}/{QUIZ_QUESTIONS.length}</span>
        </div>
        <div className="h-2 w-full bg-slate-800 rounded-full overflow-hidden">
          <div
            className="h-full bg-brand-neon transition-all duration-500 ease-out shadow-[0_0_10px_rgba(16,185,129,0.5)]"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Question Card */}
      <div className="w-full glass-panel p-6 md:p-10 rounded-2xl shadow-2xl border-t border-slate-700 animate-fade-in">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-white">
          {currentQuestion.question}
        </h2>

        <div className="space-y-4">
          {currentQuestion.options.map((option, idx) => (
            <button
              key={idx}
              onClick={() => handleOptionSelect(idx)}
              className="w-full text-left p-5 rounded-xl border border-slate-700 bg-slate-900/50 hover:bg-slate-800 hover:border-brand-neon/50 hover:shadow-[0_0_15px_rgba(16,185,129,0.1)] transition-all duration-200 group flex items-center justify-between"
            >
              <span className="font-medium text-lg text-slate-200 group-hover:text-white">{option}</span>
              <div className="w-6 h-6 rounded-full border-2 border-slate-600 group-hover:border-brand-neon flex items-center justify-center">
                <div className="w-3 h-3 rounded-full bg-brand-neon opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 text-slate-500 text-sm flex items-center gap-2">
        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
        +1.402 pessoas fizeram este teste hoje
      </div>
    </div>
  );
};

export default Quiz;